import { render, staticRenderFns } from "./ModalPageWidgets.vue?vue&type=template&id=74c40052&"
import script from "./ModalPageWidgets.vue?vue&type=script&lang=js&"
export * from "./ModalPageWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports